// this file was autogenerated by reading the translations-csv files, please do not touch and refer to the csv 
export default {
  "action.sign-in": "Accedi",
  "action.sign-up": "Registrati",
  "action.sign-in-google": "Accedi con Google",
  "action.sign-in-linkedin": "Accedi con Linkedin",
  "action.sign-up-google": "Registrati con Google",
  "action.sign-up-linkedin": "Registrati con Linkedin",
  "action.logout": "Esci",
  "action.save": "Salva",
  "action.apply": "Candidati ora",
  "action.filter": "Filtro",
  "action.add": "Inserisci",
  "action.update": "Aggiorna",
  "action.close": "Chiuso",
  "action.send": "Spedisci",
  "action.delete": "Elimina",
  "action.modify": "Modifica",
  "action.previous": "Precedente",
  "action.next": "Successivo",
  "action.cancel": "Elimina candidatura",
  "action.upload-image": "Carica nuova immagine",
  "action.upload-cv": "Carica il tuo CV",
  "action.detail": "Vedi dettagli",
  "action.back-to-profile": "Vedi profilo",
  "action.applied": "Applicato",
  "action.applicare": "Conferma",
  "action.upload-CV": "Carica il tuo curriculum",
  "action.validateprofilo": "Ora candidati",
  "action.delete-photo": "Elimina foto",
  "action.deleteCV": "Cancella CV",
  "action.downloadCV": "Scarica CV",
  "profilo.completo": "Profilo completato correttamente",
  "profilo.incompleto": "Profilo incompleto, per favore completa i dati richiesti",
  "complete.the.profile": "Aggiorna il tuo profilo!",
  "warning.maxsizefile": "Dimensione massima consentita: {size}Mb",
  "action.contattaci": "Contattaci"
};